export default __webpack_public_path__ + "static/media/3_a._badass.d58779e6.png";